module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f62e.2312e90b.svg";